import React from "react";
import orderBy from "lodash/orderBy";
import { withTranslation } from "react-i18next";
import EditorSessionTable from "./EditorSessionTable";
import ToolTip from "../../../../parts/tooltip";
import SvgIcon from "../../../../parts/SvgIcon";
import moment from "moment";
import { groupExercisesByComplex } from "../../../../utils/complex";
import { RillContext } from "../../../../rill/RillReact/share/base";

class EditorWeekColumn extends React.Component {
  constructor(props) {
    super(props);

    this._exerciseListForSession = this._exerciseListForSession.bind(this);
  }

  _exerciseListForSession(session, sessionIndex) {
    const exerciseList =
      session && session.exercises
        ? this.props.exercises.filter((ex) => {
            return session.exercises.find((exId) => ex._id === exId);
          })
        : [];
    const groupedExerciseList = groupExercisesByComplex(exerciseList);

    const keyId = `editor_session_table${sessionIndex}_${this.props.column}`;

    return (
      <EditorSessionTable
        {...this.props}
        isProgramEditor={true}
        altClass="alt-week-view"
        exerciseList={groupedExerciseList}
        ungroupedExercises={exerciseList}
        sessionIndex={sessionIndex}
        session={session}
        keyId={keyId}
        key={keyId}
        opacity={
          this.props.editingWorkouts.length &&
          !this.props.editingWorkouts.includes(keyId)
        }
        workoutOpacityCallback={this.props.workoutOpacityCallback}
        exercisesInClipboard={this.context?.locals?.query?.exercisesInClipboard}
      />
    );
  }

  render() {
    const {
      week,
      cycle,
      program,
      programNumber,
      column,
      selectedWeeks,
      handleSelectWeek,
      numberOfWeeks,
      t,
    } = this.props;

    const sessions = orderBy(week, "order");

    // If there is only one week, the second column will be undefined
    if (!week) return <span />;
    const selecting = selectedWeeks?.length > 0;
    const selected = selectedWeeks?.includes(sessions[0].week);
    const unchecked = selecting && !selected;

    const storeType = cycle.storeType || "programs";
    const notSingleWorkout = storeType !== "single-workout";
    const isProgram = storeType === "programs";

    return (
      <li
        className={`week${unchecked ? " unchecked" : ""}${
          selecting ? " selecting" : ""
        }`}
        key={`week_column_${column}`}
      >
        {notSingleWorkout && (
          <header>
            <div>
              <p className="s2 clipped">
                {storeType === "teams"
                  ? `${moment(program.startDate, "YYYYMMDD").format(
                      "MMM D"
                    )} - ${moment(program.startDate, "YYYYMMDD")
                      .add(6, "days")
                      .format("MMM D")}`
                  : t("athlete-portal:programs.weekN", {
                      n: sessions[0].week,
                    })}
              </p>
              {!!handleSelectWeek && !!selectedWeeks && numberOfWeeks > 1 ? (
                <button
                  className="p-0"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSelectWeek(sessions[0].week);
                  }}
                >
                  <SvgIcon
                    src={
                      selected
                        ? "/img/new-icons/checked-square.svg"
                        : "/img/new-icons/unchecked-square.svg"
                    }
                    noFilterOnLight={selected}
                  />
                </button>
              ) : null}
            </div>
            <div className={selecting ? "invisible" : ""}>
              {isProgram && (
                <ToolTip
                  id="duplicate-week-tooltip"
                  body={t("athlete-portal:programs.duplicateWeek")}
                  float={false}
                  place="bottom"
                >
                  <a
                    data-button-type="secondary"
                    role="button"
                    href={`/actions/refresh/?modal[type]=duplicate-week&week=${sessions[0].week}`}
                  >
                    <SvgIcon src="/img/new-icons/duplicate.svg" />
                  </a>
                </ToolTip>
              )}

              {notSingleWorkout && (
                <ToolTip
                  id="week-progression-tooltip"
                  body={t("athlete-portal:programs.weekProgression")}
                  float={false}
                  place="bottom"
                >
                  <a
                    data-button-type="secondary"
                    role="button"
                    href={`/actions/refresh/?modal[type]=progression&week=${sessions[0].week}&program=${programNumber}&cycle=${cycle._id}&type=week`}
                  >
                    <SvgIcon src="/img/new-icons/percentage-square.svg" />
                  </a>
                </ToolTip>
              )}

              {storeType !== "teams" && (
                <ToolTip
                  id={`delete-week-${column}-tooltip`}
                  body={t("athlete-portal:programs.deleteWeekTooltip")}
                  float={false}
                  place="bottom"
                >
                  <a
                    data-button-type="secondary"
                    role="button"
                    href={`/actions/cycle/delete-week/${cycle._id}/${programNumber}/${sessions[0].week}`}
                  >
                    <SvgIcon
                      src="/img/new-icons/red-trash.svg"
                      noFilterOnLight
                    />
                  </a>
                </ToolTip>
              )}
            </div>
          </header>
        )}
        <ul className="workouts">
          {sessions.map(this._exerciseListForSession)}
        </ul>
        {week.length < 7 && !selecting && notSingleWorkout && (
          <a
            className="add-workout"
            href={`/actions/cycle/addWorkout/${cycle._id}?program=${program.order}&week=${column}`}
          >
            <SvgIcon
              src="/img/new-icons/add-square-outline.svg"
              className="h-11 w-11"
            />
            <p className="p4">{t("athlete-portal:programs.addWorkout")}</p>
          </a>
        )}
      </li>
    );
  }
}
EditorWeekColumn.contextType = RillContext;

export default withTranslation(["athlete-portal", "common"])(EditorWeekColumn);
